import(/* webpackMode: "eager", webpackExports: ["DurationDropdown"] */ "/app/apps/website/src/app/(rootLayout)/destinations/_components/duration-dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/website/src/assets/images/destinations/hero-2.jpeg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/faq/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea","ScrollBar"] */ "/app/packages/ui/src/components/ui/scroll-area.tsx");
